import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  author: string;
  publishDate: string;
  readCount: string;
  image: string;
}

export default function ArticleCard({ id, title, slug, excerpt, category, author, publishDate, readCount, image }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-md overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${title} - 黄油网页游戏合集`}
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="inline-block px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
              {category}
            </span>
            <span className="text-xs text-foreground-400">{publishDate}</span>
          </div>
          <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-1.5 line-clamp-1">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
            {excerpt}
          </p>
        </div>
        <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
          <span>{author}</span>
          <span className="flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            {readCount}
          </span>
        </div>
      </div>
    </Link>
  );
}